import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Page from '../../components/Page';
import client from '../../lib/feathers';

export default function Suggestions() {
  const [suggestions, setSuggestions] = useState([]);
  const [status, setStatus] = useState('new');
  const [error, setError] = useState('');
  const statusList = ['new', 'approved', 'rejected'];

  const formatSuggestionType = (type) => {
    switch (type) {
      case 'good_info':
        return 'This is a real place';
      case 'not_a_venue':
        return 'This is not a real place';
      case 'bad_info':
        return 'Some data is wrong';
      case 'accommodation':
        return 'Accommodation suggestion';
      default:
        return type;
    }
  };

  const getSuggestions = async () => {
    try {
      setError('');
      const service = client.service('admin/suggestion');
      const query = {
        $limit: 1000,
        $sort: {
          createdAt: 1,
        },
        status,
      };

      const result = await service.find({
        query,
      });

      setSuggestions(result.data);
    } catch (e) {
      setError('Failed to load suggestions.');
      console.log('error', e);
    }
  };

  const updateSuggestion = async (id, st) => {
    try {
      setError('');
      const service = client.service('admin/suggestion');
      const data = { status: st };

      await service.patch(id, data);
      getSuggestions();
    } catch (e) {
      setError(`Failed to ${st === 'approved' ? 'approve' : 'reject'} suggestion. Please try again.`);
      console.log('error updating suggestion', e);
    }
  };

  useEffect(() => {
    getSuggestions();
  }, [status]);
  return (
    <Page title="Suggestions">
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">

        <nav className="flex" aria-label="Breadcrumb">
          <Breadcrumb elements={[{ name: 'Suggestions' }]} />
        </nav>
        <div className="mt-3 sm:mt-0 sm:ml-4">
          <button onClick={() => getSuggestions()} type="button" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
            Refresh
          </button>
        </div>
      </div>

      {error && (
        <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
          {error}
        </div>
      )}

      <div>
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">Select a tab</label>
          <select onChange={(e) => setStatus(e.target.value)} value={status} id="tabs" name="tabs" className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm rounded-md">
            {statusList.map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {statusList.map((s) => {
                let styles = 'capitalize border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm';
                if (status === s) {
                  styles = 'capitalize border-gray-500 text-gray-600 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm';
                }
                return <a href="#" onClick={() => setStatus(s)} className={styles} aria-current="page" key={s}>{s}</a>;
              })}
            </nav>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Suggestion Details
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Listing & Contact
                    </th>
                    <th scope="col" className="relative px-6 py-3">
                      <span className="sr-only">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {suggestions.map((l) => (
                    <tr className="hover:bg-gray-100 cursor-pointer" key={l.id}>
                      <td className="px-6 py-4">
                        <div className="flex items-start">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div className={`h-10 w-10 rounded-full pt-2 text-center text-white text-xs ${l.staff ? 'bg-blue-600' : 'bg-gray-600'}`}>
                              {l.staff ? 'STAFF' : 'USER'}
                            </div>
                          </div>
                          <div className="ml-4 flex-1">
                            <div className="text-sm font-medium text-gray-900">
                              {formatSuggestionType(l.type)}
                            </div>
                            {l.staff && (
                              <div className="text-xs text-blue-600 font-medium">
                                Staff/Owner submission
                              </div>
                            )}
                            {l.user?.username && (
                              <div className="text-xs text-gray-600 font-medium">
                                Submitted by: {l.user.username}
                              </div>
                            )}
                            {l.type === 'accommodation' && l.suggestionAccommodations && l.suggestionAccommodations.length > 0 ? (
                              <div className="mt-2 space-y-1">
                                {l.suggestionAccommodations.map((sa) => (
                                  <div key={sa.id} className="flex items-center gap-2 text-sm">
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${sa.action === 'add' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                      {sa.action === 'add' ? 'Add' : 'Remove'}
                                    </span>
                                    <span className="text-gray-700">
                                      {sa.accommodation ? sa.accommodation.name : sa.accommodationId}
                                    </span>
                                    {sa.accommodation && (
                                      <span className="text-xs text-gray-400 capitalize">
                                        ({sa.accommodation.type})
                                      </span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              l.suggestion && (
                                <div className="text-sm text-gray-700 mt-1">
                                  <strong>Details:</strong> {l.suggestion}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm font-medium text-gray-900">
                          {l.listing?.name || 'Unknown Listing'}
                        </div>
                        <div className="mt-1">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">
                            <a href={`/admin/listings/${l.listingId}/`} className="hover:underline">
                              View Listing
                            </a>
                          </span>
                        </div>
                        {l.email && (
                          <div className="text-sm text-gray-500 mt-1">
                            <strong>Contact:</strong> {l.email}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        {status === 'new' ? (
                          <>
                            <a href="#" onClick={(e) => { e.preventDefault(); updateSuggestion(l.id, 'approved'); }} className="text-green-600 hover:text-green-900">Approve</a>
                            <span className="mx-2 text-gray-300">|</span>
                            <a href="#" onClick={(e) => { e.preventDefault(); updateSuggestion(l.id, 'rejected'); }} className="text-red-600 hover:text-red-900">Reject</a>
                          </>
                        )
                          : <></>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}
